import { render, staticRenderFns } from "./UploadNew.vue?vue&type=template&id=91e7ac42&scoped=true&"
import script from "./UploadNew.vue?vue&type=script&lang=js&"
export * from "./UploadNew.vue?vue&type=script&lang=js&"
import style0 from "./UploadNew.vue?vue&type=style&index=0&id=91e7ac42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e7ac42",
  null
  
)

export default component.exports